<div class="FcAgEditor__MenuBar"
     [ngClass]="{'FcAgEditor--Disabled': disabled, 'FcAgEditor__MenuBar--Reverse': dropdownPlacement === 'top'}">

    <ng-container *ngFor="let toolbarItem of toolbar; let lastToolbarItem = last; trackBy: trackByIndex">
        <ng-container *ngFor="let item of toolbarItem; let lastItem = last; trackBy: trackByIndex">

            <!-- toggle icons -->
            <fc-ag-toggle-command [toolbarItem]="item" [class]="iconContainerClass" *ngIf="toggleCommands.includes(item)">
            </fc-ag-toggle-command>

            <!-- link -->
            <fc-ag-link [class]="iconContainerClass" *ngIf="item === 'link'"></fc-ag-link>

            <!-- image -->
            <fc-ag-image [class]="iconContainerClass" *ngIf="item === 'image'">
            </fc-ag-image>

            <!-- dropdown -->
            <ng-container *ngIf="isDropDown(item)">
                <fc-ag-dropdown *ngFor="let dropdownItem of getDropdownItems(item) | keyvalue; trackBy: trackByIndex"
                              [class]="dropdownContainerClass" [group]="dropdownItem.key" [items]="dropdownItem.value">
                </fc-ag-dropdown>
            </ng-container>

            <!-- text color picker -->
            <fc-ag-color-picker [class]="iconContainerClass" *ngIf="item === 'text_color'" type="text_color"
                              [presets]="presets">
            </fc-ag-color-picker>
            <!-- background color picker -->
            <fc-ag-color-picker [class]="iconContainerClass" *ngIf="item === 'background_color'" type="background_color"
                              [presets]="presets">
            </fc-ag-color-picker>

            <!-- table -->
            <fc-table-menu *ngIf="item === 'table'"></fc-table-menu>
            
            <!-- seperator -->
            <div [class]="seperatorClass" *ngIf="lastItem && !lastToolbarItem"></div>
        </ng-container>
    </ng-container>

    <!-- custom menu -->
    <ng-container *ngIf="customMenuRef">
        <ng-container [ngTemplateOutlet]="customMenuRef"></ng-container>
    </ng-container>

</div>
